export default __webpack_public_path__ + "static/media/085.5a668c66.jpeg";